module.exports = __webpack_public_path__ + "img/Pic_TB_B.46614444.png";